"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MusicConstants {
}
MusicConstants.KEYS_IN_OCTAVE = 12;
MusicConstants.SMALLEST_PROGRAM_NUMBER = 0;
MusicConstants.LARGEST_PROGRAM_NUMBER = 127;
exports.default = MusicConstants;
